// src/router/smart-router/index.ts
import { SmartRouter } from "./router.js";
export {
  SmartRouter
};
